import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreInfoInactive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99984 8.66683C8.36803 8.66683 8.6665 8.36835 8.6665 8.00016C8.6665 7.63197 8.36803 7.3335 7.99984 7.3335C7.63165 7.3335 7.33317 7.63197 7.33317 8.00016C7.33317 8.36835 7.63165 8.66683 7.99984 8.66683Z",
			stroke: "#B6BEDC",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6665 8.66683C13.0347 8.66683 13.3332 8.36835 13.3332 8.00016C13.3332 7.63197 13.0347 7.3335 12.6665 7.3335C12.2983 7.3335 11.9998 7.63197 11.9998 8.00016C11.9998 8.36835 12.2983 8.66683 12.6665 8.66683Z",
			stroke: "#B6BEDC",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.33317 8.66683C3.70136 8.66683 3.99984 8.36835 3.99984 8.00016C3.99984 7.63197 3.70136 7.3335 3.33317 7.3335C2.96498 7.3335 2.6665 7.63197 2.6665 8.00016C2.6665 8.36835 2.96498 8.66683 3.33317 8.66683Z",
			stroke: "#B6BEDC",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMoreInfoInactive;
